/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForSyncBudgets extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForSyncBudgets");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForSyncBudgets.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForSyncBudgets>): BackgroundJobPayloadForSyncBudgets {
        let obj = Object.assign(new BackgroundJobPayloadForSyncBudgets(), model);
        BackgroundJobPayloadForSyncBudgets.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForSyncBudgets>): BackgroundJobPayloadForSyncBudgets {
        if (!model) return null;
        return BackgroundJobPayloadForSyncBudgets.newInstance(<BackgroundJobPayloadForSyncBudgets> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForSyncBudgets) {
        if (!obj) return;

        models.BackgroundJobPayloadForSyncBudgets.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForSyncBudgets): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForSyncBudgets.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of cloud accounts
     */
    cloud_account_ids: Array<string>;

    account_event_type: models.SyncBudgetEventType;

    user_id: string;

}
